import React from 'react'
import { useAuth } from '../../Context/ContextProvider'

function Content({ newsDetail }) {
  const { loading } = useAuth()
  return (
    <div>
      {!newsDetail || loading ? <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}><div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div></div> : <div className='container blog-detail-container'>
        <h1 className='heading-title'>{newsDetail?.title}</h1>
        <img src={newsDetail?.image} alt={newsDetail?.title} />
        <div dangerouslySetInnerHTML={{ __html: newsDetail?.description }} />
      </div>}
    </div>
  )
}

export default Content